import { fadeIn, hide, show, slideDown, slideUp } from "./Helpers/animations";

const laboratoryTests = document.querySelectorAll('.lab-card') as NodeListOf<HTMLDivElement>;
const searchInput = document.getElementById('lab-text-input') as HTMLInputElement | null;
const categoryFilterGroups = document.querySelectorAll('.category-filter') as NodeListOf<HTMLFieldSetElement>;
const categoryFilterToggles = document.querySelectorAll('.category-filter summary') as NodeListOf<HTMLButtonElement>;
const categoryFilters = document.querySelectorAll('.category-filter input[type=checkbox]') as NodeListOf<HTMLInputElement>;
const totalMatchingText = document.querySelector('.lab-total') as HTMLElement | null;
const clearFiltersButton = document.querySelector('.clear-filters') as HTMLButtonElement | null;
const alertMessage = document.querySelector('.alert-message') as HTMLParagraphElement | null;
const buttonFilters = document.querySelectorAll('.button-filter') as NodeListOf<HTMLButtonElement>;

const updateFilterCounts = (selectedCategories?: { [key: string]: string[] }) => {
    categoryFilterToggles.forEach(toggle => {
        const selectedCountText = toggle.querySelector('.category-count') as HTMLSpanElement | null;
        if (selectedCountText) {
            if (selectedCategories && toggle.dataset.id && selectedCategories[toggle.dataset.id]) {
                selectedCountText.innerText = `(${selectedCategories[toggle.dataset.id].length})`;
            } else {
                selectedCountText.innerText = '';
            }
        }
    });
};

const getLabsMatchingText: (labCards: HTMLDivElement[]) => HTMLDivElement[] = labCards => {        
    if (searchInput?.value && searchInput.value.length > 2) {
        const searchString = searchInput.value.toLowerCase();
        return labCards.filter(labCard => {
            let found = false;
            const labTitleElement = labCard.querySelector('a') as HTMLAnchorElement | null;
            const labAbstractElement = labCard.querySelector('p') as HTMLParagraphElement | null;

            
            if (labTitleElement?.innerText?.toLowerCase().includes(searchString)) {
                found = true;
                addHighlights(labTitleElement, searchString);
            }

            if (labAbstractElement?.innerText.toLowerCase().includes(searchString)) {
                found = true;
                addHighlights(labAbstractElement, searchString);
            }

            return found;
        });
    } else {
        return labCards;
    }
};

const addHighlights: (element: HTMLElement, searchPhrase: string) => void = (element, searchPhrase) => {
    const rx = new RegExp(`(${searchPhrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
    element.innerHTML = element.innerHTML.replace(rx, '<span class="search-highlight">$1</span>');
};

const removeHighlightTag: (labHighlight: HTMLSpanElement) => void = labHighlight => {
    if (labHighlight.parentElement?.innerHTML) {
        labHighlight.replaceWith("Test");
        labHighlight.parentElement.innerHTML = labHighlight.parentElement.innerHTML.replace(labHighlight.outerHTML, labHighlight.innerHTML);
    }
};

const getLabsMatchingCategories: (labCards: HTMLDivElement[]) => HTMLDivElement[] = labCards => {
    const selectedCategories = [...categoryFilterGroups].reduce((accumulator, categoryGroup) => {
        const checkedCategories = categoryGroup.querySelectorAll('input:checked') as NodeListOf<HTMLInputElement>;
        for (const checkbox of checkedCategories) {
            if (categoryGroup.dataset?.id) {
                if (accumulator[categoryGroup.dataset.id]) {
                    accumulator[categoryGroup.dataset.id].push(checkbox.value);
                } else {
                    accumulator[categoryGroup.dataset.id] = [checkbox.value];
                }
            }
        }

        return accumulator;
    }, {} as { [key: string]: string[] });

    updateFilterCounts(selectedCategories);    

    if (Object.keys(selectedCategories).length) {
        buttonFilters.forEach(button => {
            button.disabled = Object.keys(selectedCategories).some(parentId => button.dataset.category && selectedCategories[parentId].includes(button.dataset.category));
        });

        return labCards.filter(labCard => {
            const categories = labCard.dataset.categories?.split('|');
            return categories?.length && Object.keys(selectedCategories).every(parentId => selectedCategories[parentId].some(checkedCategory => categories.includes(checkedCategory)));
        });
    } else {
        buttonFilters.forEach(button => button.disabled = false);
        return labCards;
    }
};

let debounceInterval: number | undefined;

searchInput?.addEventListener('input', () => {        
    searchInput.value.length > 0 && searchInput.value.length < 3 ?
        show(alertMessage) :
        hide(alertMessage);

    clearInterval(debounceInterval);
    debounceInterval = setInterval(() => {
        let matchingLabCards: HTMLDivElement[];
        (document.querySelectorAll('.lab-card-container .search-highlight') as NodeListOf<HTMLSpanElement>).forEach(highlightTag => highlightTag.replaceWith(...highlightTag.childNodes));
        
        if (searchInput?.value && searchInput.value.length > 2) {
            hide(alertMessage);

            matchingLabCards = getLabsMatchingText([...laboratoryTests]);
            matchingLabCards = getLabsMatchingCategories(matchingLabCards);

            laboratoryTests.forEach(labCard => hide(labCard));
            matchingLabCards.forEach(labCard => fadeIn(labCard, 200, { animateOnlyIfToggled: true }));
            
            if (totalMatchingText) {
                totalMatchingText.innerText = `${matchingLabCards.length}`;
            }
        } else {
            matchingLabCards = getLabsMatchingCategories([...laboratoryTests]);
            matchingLabCards.forEach(labCard => fadeIn(labCard, 200, { animateOnlyIfToggled: true }));
        }

        if (totalMatchingText) {
            totalMatchingText.innerText = `${matchingLabCards.length}`;
        }

        clearInterval(debounceInterval);
        debounceInterval = undefined;
    }, 500);
});

categoryFilters.forEach(filter => filter.addEventListener('change', () => {
    searchInput?.value && searchInput.value.length > 0 && searchInput.value.length < 3 ?
        show(alertMessage) :
        hide(alertMessage);

    let matchingLabCards = getLabsMatchingCategories([...laboratoryTests]);
    matchingLabCards = getLabsMatchingText(matchingLabCards);

    laboratoryTests.forEach(labCard => hide(labCard));
    matchingLabCards.forEach(labCard => fadeIn(labCard, 200, { animateOnlyIfToggled: true }));
    
    if (totalMatchingText) {
        totalMatchingText.innerText = `${matchingLabCards.length}`;
    }
}));

clearFiltersButton?.addEventListener('click', () => {
    if (searchInput) searchInput.value = '';
    categoryFilterGroups.forEach(filterGroup => (filterGroup.querySelectorAll('input:checked') as NodeListOf<HTMLInputElement>).forEach(input => input.checked = false));
    (document.querySelectorAll('.button-filter') as NodeListOf<HTMLButtonElement>).forEach(button => button.disabled = false);

    hide(alertMessage);

    if (totalMatchingText) {
        totalMatchingText.innerText = `${laboratoryTests.length}`;
    }    

    updateFilterCounts();

    (document.querySelectorAll('.lab-card-container .search-highlight') as NodeListOf<HTMLSpanElement>).forEach(highlightTag => highlightTag.replaceWith(...highlightTag.childNodes));
    laboratoryTests.forEach(labCard => fadeIn(labCard, 200, { animateOnlyIfToggled: true }));
});

buttonFilters.forEach(button => {
    button.addEventListener('click', () => {
        if (button.dataset?.category) {
            (document.querySelectorAll(`.button-filter[data-category="${button.dataset.category}"]`) as NodeListOf<HTMLButtonElement>).forEach(matchingButton => matchingButton.disabled = true);

            categoryFilterGroups.forEach(filterGroup => {
                [...(filterGroup.querySelectorAll('input') as NodeListOf<HTMLInputElement>)]
                    .filter(checkbox => checkbox.value === button.dataset?.category)
                    .forEach(checkbox => checkbox.checked = true);
                
                let matchingLabCards = getLabsMatchingText([...laboratoryTests]);
                matchingLabCards = getLabsMatchingCategories(matchingLabCards);

                laboratoryTests.forEach(labCard => hide(labCard));
                matchingLabCards.forEach(labCard => fadeIn(labCard, 200, { animateOnlyIfToggled: true }));

                if (totalMatchingText) {
                    totalMatchingText.innerText = `${matchingLabCards.length}`;
                }
            });
        }
    });
});

categoryFilterToggles.forEach(toggle => toggle.addEventListener('click', () => {
    if (toggle.ariaExpanded === 'true') {
        slideUp(toggle.ariaControlsElements?.[0] as HTMLElement | null | undefined, 200);
        toggle.ariaExpanded = 'false';
    } else {
        slideDown(toggle.ariaControlsElements?.[0] as HTMLElement | null | undefined, 200);
        toggle.ariaExpanded = 'true';
        categoryFilterToggles.forEach(filterToggle => {
            if (filterToggle !== toggle) {
                filterToggle.ariaExpanded = 'false';
                slideUp(filterToggle.ariaControlsElements?.[0] as HTMLElement | null | undefined, 200);
            }
        });
    }
}));
